import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextService } from '@core/providers/context/context.service';
import { ContextObject } from '@shared/interfaces/login-object';

@Service()
export class GroupsGuard {
  private contextService = inject(ContextService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.contextService
      .getContext$()
      .pipe(map((context: ContextObject) => ContextService.isAccountContext(context)));
  }
}
